/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_HistoryInputs */

const en_chat_history = /** @type {(inputs: Chat_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat History`)
};

const nl_chat_history = /** @type {(inputs: Chat_HistoryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chatgeschiedenis`)
};

/**
* | output |
* | --- |
* | "Chat History" |
*
* @param {Chat_HistoryInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const chat_history = /** @type {((inputs?: Chat_HistoryInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_HistoryInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_chat_history(inputs)
	return en_chat_history(inputs)
});